import { useTranslation } from 'react-i18next';
import { Sparkles } from 'lucide-react';

import { cn } from '@/lib/cn';

interface PaywallProps {
  /** Feature name (e.g. "AI coach", "Deck builder") for headline copy */
  feature: string;
  className?: string;
}

/**
 * Inline paywall card shown when a `free`-tier user hits a `pro`-only
 * screen. Mini Apps can't sell subscriptions directly (Telegram Stars
 * could in the future), so this is a static "what you'd get" sell with
 * no checkout button. Once Stars / web shop billing is wired up, swap
 * the placeholder copy for an `openLink` to the upgrade flow.
 */
export function Paywall({ feature, className }: PaywallProps) {
  const { t } = useTranslation('cr');
  return (
    <div
      className={cn(
        'flex flex-col items-center gap-3 rounded-xl border border-brand/40 bg-brand/10 p-6 text-center',
        className,
      )}
    >
      <span className="flex h-12 w-12 items-center justify-center rounded-full bg-brand/20 text-brand">
        <Sparkles className="h-6 w-6" strokeWidth={2.5} />
      </span>
      <h2 className="text-base font-bold text-fg">{t('paywall.title', { feature })}</h2>
      <p className="max-w-xs text-sm text-fg-muted">{t('paywall.body')}</p>
      <p className="text-[11px] text-fg-muted">{t('paywall.cta.coming')}</p>
    </div>
  );
}
